import { render, staticRenderFns } from "./ProjectEvidences.vue?vue&type=template&id=021f2862&scoped=true&"
import script from "./ProjectEvidences.vue?vue&type=script&lang=js&"
export * from "./ProjectEvidences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f2862",
  null
  
)

export default component.exports